/* Generic product hero: pack ladder + option chips + per-unit picker. */
(function(){
  var r=document.getElementById('ghBuy');
  if(!r||r.dataset.i==='1')return; r.dataset.i='1';
  var M=document.getElementById('ghMain'),fVar=document.getElementById('ghVariant');
  var nameEl=document.getElementById('ghOptName');
  var soloNote=r.getAttribute('data-solo-note')||'';
  var unitWord=r.getAttribute('data-unit-word')||'Article';
  var V=[],MT={};
  try{ V=JSON.parse(document.getElementById('ghPrices').textContent); }catch(e){}
  try{ MT=JSON.parse(document.getElementById('ghMeta').textContent); }catch(e){}

  var packFirst = MT.packPos===1;
  var opt = packFirst ? MT.cur2 : MT.cur;
  var pack = packFirst ? MT.cur : MT.cur2;
  var hasOpt = (MT.optValues||[]).length>0;

  function fmt(c){ return '€'+(c/100).toFixed(2).replace('.',','); }
  function qtyOf(l){ var n=parseInt(l,10); return isNaN(n)?1:n; }
  function find(pk,op){
    for(var i=0;i<V.length;i++){
      var x=V[i];
      var xp = packFirst ? x.o1 : x.o2;
      var xo = packFirst ? x.o2 : x.o1;
      if(xp===pk && (!hasOpt || xo===op)) return x;
    }
    return null;
  }
  function unitBase(){
    for(var i=0;i<V.length;i++){
      var x=V[i];
      var xp = packFirst ? x.o1 : x.o2;
      var xo = packFirst ? x.o2 : x.o1;
      if(qtyOf(xp)===1 && (!hasOpt || xo===opt)) return x;
    }
    return null;
  }

  var buildUnits = hasOpt ? window.xUnitsInit({
    ns:'gh', unitWord:unitWord, hint:(MT.optName||'')+' au choix',
    options:[{label:MT.optName,values:MT.optValues}],
    onFirstChange:function(vals){
      opt=vals[0];
      if(nameEl)nameEl.textContent=opt;
      r.querySelectorAll('[data-opt]').forEach(function(x){x.setAttribute('aria-pressed',x.getAttribute('data-opt')===opt?'true':'false');});
      sync(true);
    }
  }) : function(){};

  function sync(skipUnits){
    var cur=find(pack,opt);
    if(cur){ fVar.value=cur.id;
      try{var u=new URL(window.location.href);u.searchParams.set('variant',cur.id);window.history.replaceState({},'',u);}catch(e){} }
    var base=unitBase();
    r.querySelectorAll('[data-pack]').forEach(function(card){
      var label=card.getAttribute('data-pack');
      var x=find(label,opt);
      var now=card.querySelector('.gh-o__now'),was=card.querySelector('.gh-o__was'),
          sv=card.querySelector('.gh-o__sv'),un=card.querySelector('.gh-o__unit');
      if(!x){ card.style.display='none'; return; }
      card.style.display='';
      var n=qtyOf(label);
      var ref=base?base.p*n:0;
      var saves=(n>1&&ref>x.p);
      if(now)now.textContent=fmt(x.p);
      if(was){ was.textContent=saves?fmt(ref):''; was.setAttribute('data-show',saves?'true':'false'); }
      if(un)un.textContent=(n>1)?(fmt(Math.round(x.p/n))+' l’unité'):'';
      if(sv){
        if(saves){ sv.textContent='Vous économisez '+fmt(ref-x.p); sv.setAttribute('data-save','true'); }
        else { sv.textContent=soloNote; sv.setAttribute('data-save','false'); }
      }
    });
    if(!skipUnits) buildUnits(qtyOf(pack),[opt]);
  }

  document.querySelectorAll('.gh-gal__b').forEach(function(b){
    b.addEventListener('click',function(){
      if(M)M.src=b.dataset.src;
      document.querySelectorAll('.gh-gal__b').forEach(function(x){x.setAttribute('aria-current',x===b?'true':'false');});
    });
  });
  r.querySelectorAll('[data-pack]').forEach(function(o){
    function pick(){ pack=o.getAttribute('data-pack');
      r.querySelectorAll('[data-pack]').forEach(function(x){var on=x===o;x.setAttribute('data-on',on?'true':'false');x.setAttribute('aria-checked',on?'true':'false');});
      sync(); }
    o.addEventListener('click',pick);
    o.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();pick();}});
  });
  r.querySelectorAll('[data-opt]').forEach(function(b){
    b.addEventListener('click',function(){
      opt=b.getAttribute('data-opt');
      if(nameEl)nameEl.textContent=opt;
      r.querySelectorAll('[data-opt]').forEach(function(x){x.setAttribute('aria-pressed',x.getAttribute('data-opt')===opt?'true':'false');});
      sync();
    });
  });
  if(nameEl)nameEl.textContent=opt||'';
  sync();
})();
